import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';

import { useSelector } from 'react-redux';
import translate from '../../libs/i18n';

import SunIcon from '../../assets/svgs/SunIcon';
import { WindowWidthLevelSelectStyle } from './WindowWidthLevelSelectStyle'; 

const WindowWidthLevelSelect = ({
  types,
  selected,
  parent,
  placeholder,
  disabled,
  handleSelect,
}) => {
  const [show, setShow] = useState(false);
  const language = useSelector((state) => state.settings.language);

  // Fecha o dropdown se o `selected` ou `parent` mudar
  useEffect(() => {
    if (selected) {
      setShow(false);
    }
  }, [parent?.id, selected]);

  // Monta o nome que será traduzido/clickado
  const selectedName = selected?.id === parent?.id
    ? 'Any'
    : translate(selected?.name?.toLowerCase().replaceAll(' ', ''), language);

  return (
    <WindowWidthLevelSelectStyle
      className={show ? 'show' : ''}
      disabled={disabled}
    >
      <div className="icon-container">
        <button
          type="button"
          disabled={disabled}
          className={`icon-button${show ? ' active' : ''}`}
          onClick={() => !disabled && setShow(!show)}
        >
          <SunIcon />
        </button>
      </div>

      {show && (
        <div className="types-list-container">
          {types?.map((type) => {
            if (type?.id && type?.name?.length) {
              const isSelected = selected?.id === type?.id;
              return (
                <button
                  key={type?.id}
                  className={`type-option${isSelected ? ' selected' : ''}`}
                  type="button"
                  onClick={() =>
                    handleSelect(isSelected ? null : type)
                  }
                >
                  <div className="option-name">
                    {translate(
                      type.name
                        ?.toLowerCase()
                        .replaceAll(' ', ''),
                      language
                    )}
                  </div>
                </button>
              );
            }
            return null;
          })}
        </div>
      )}
    </WindowWidthLevelSelectStyle>
  );
};

WindowWidthLevelSelect.propTypes = {
  types: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
      name: PropTypes.string,
    })
  ),
  selected: PropTypes.shape({
    id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    name: PropTypes.string,
  }),
  parent: PropTypes.shape({
    id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    name: PropTypes.string,
  }),
  placeholder: PropTypes.string,
  disabled: PropTypes.bool,
  handleSelect: PropTypes.func.isRequired,
};

WindowWidthLevelSelect.defaultProps = {
  types: [],
  selected: null,
  parent: null,
  placeholder: '',
  disabled: false,
};

export default WindowWidthLevelSelect;
